import TwoFactorCard from "../components/TwoFactorCard/TwoFactorCard";

export default function TwoFactorSettings() {
  return (
    <div>
      <TwoFactorCard />
    </div>
  );
}
